import {showNotice} from "../helpers/functions.js";

let interval: any;
const symbols = '$%^#&*';

let c=0;
const $html = $('html')
    .on('mouseover', '.bug-button', function (){
        const $this = $(this);
        interval = setInterval(()=>{
            const randomString = Array.from(Array(13), ()=>symbols[Math.floor(Math.random()*symbols.length)]).join('');
            $this.attr('data-balloon', randomString)
        }, 100);
    })
    .on('mouseout', '.bug-button', ()=>clearInterval(interval))
    .on('click', '.bug-button', function(){
        showNotice("Не кликай!<br>А то я ж сломаюсь!", 'Ты что делаешь?', 'error', true);
        if($(this).hasClass('blocked')) return;
        if(++c === 3){
            $(this).addClass('blocked');
            c=0;
            $("#main-page").addClass('rotated');
            $html.css('overflow-x', 'hidden')
            setTimeout(()=>{
                $html.css('overflow-x', '')
                $(this).removeClass('blocked');
                $("#main-page").removeClass('rotated');
            }, 30_000);
        }
    });